import BaseRepository from "@/services/resources/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    record(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .include('person-blog-posts')
                    .find(id)
            )
        );
    }

    search(keywords) {
        return this.transformer.many(
            this.try(
                this.baseSearchQuery(
                    ['blog-post-modules.modules.modules'],
                    ['title', 'summary', 'blog-post-modules.modules.modules.attributes']
                    , keywords
                ).get()
            )
        ).then(collection => {
            return collection.map(record => {
                return {
                    type: 'blog-posts',
                    id: record.id,
                    text: record.title,
                    resource: record,
                    badgeVariant: 'beta',
                    badgeText: 'Blog',
                }
            })
        })
    }
}

export default Repository;
